function getDfeKeySerie(key: string) {
    return parseInt(key.substring(22, 25), 10).toString();
}

export default getDfeKeySerie;
